<template>
  <div class="login">
    <div class="container">
      <form class="login__container">
        <svg class="login__logo" width="325" height="83">
          <use xlink:href="@/assets/icons/sprite.svg#logo-new"></use>
        </svg>
        <h1 class="login__title">Вход</h1>
        <div class="field" :class="{ 'field--error': v$.login.$error }">
          <Input
            type="text"
            placeholder="Логин"
            v-model="model.login"
            :isError="v$.login.$error"
          />
          <div v-if="v$.login.$error" class="field__error-text">
            {{ v$.login.$errors[0].$message }}
          </div>
        </div>
        <div class="field" :class="{ 'field--error': v$.password.$error }">
          <Input
            type="password"
            placeholder="Пароль"
            v-model="model.password"
            :isError="v$.password.$error"
          />
          <div v-if="v$.password.$error" class="field__error-text">
            {{ v$.password.$errors[0].$message }}
          </div>
        </div>
        <button class="login__btn btn btn--green" @click="submit">
          Продолжить
        </button>
      </form>
    </div>
  </div>
</template>
<script setup lang="ts">
  import Input from "@/UI/Input.vue";
  import { computed, ref } from "vue";
  import useVuelidate from "@vuelidate/core";
  import { required, helpers } from "@vuelidate/validators";
  import router from "@/router";

  const model = ref({
    login: "",
    password: "",
  });

  const rules = computed(() => ({
    login: {
      required: helpers.withMessage("Обязательное поле", required),
    },
    password: {
      required: helpers.withMessage("Обязательное поле", required),
    },
  }));

  const v$ = useVuelidate(rules, model);

  const submit = async () => {
    const isValid = await v$.value.$validate();

    if (isValid) {
      // console.log("Отправить");
      router.push("/catalog-menu");
    }
  };
</script>
<style lang="scss">
  .login {
    &__container {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      min-height: 100dvh;
    }

    @include mediumMobile {
      &__logo {
        margin-bottom: 60px;
      }

      &__title {
        margin-bottom: 32px;
      }

      &__btn {
        margin-top: 32px;
      }
    }
  }
</style>
